<template>
	<div class="container page">

		<div class="row">
			<div class="col">
				<div class="section__header gsap-fade" v-if="news.type == 'news' && section.type !== 'teams'">
					<p class="section-title">0{{section.index}}. {{section.title}} -</p>

					<router-link
						v-if="subsection"
						class="subsection-title"
						:to="{name: 'SubSection', params: {sectionSlug: section.slug, subsectionSlug: subsection.slug}}"
						>{{subsection.title}} </router-link>

					<h1 v-if="section.type !== 'media'" class="subsection-main-title">{{subsection.title}}</h1>
				</div>

				<div class="section__header gsap-fade" v-else-if="section.type == 'teams'">
					<p class="section-title">0{{section.index}}. {{section.title}} -</p>

					<router-link
						v-if="teamSection"
						class="subsection-title"
						:to="{name: 'SubSection', params: {sectionSlug: section.slug, subsectionSlug: teamSection.slug}}"
						>{{teamSection.name}} </router-link>

					<h1 v-if="section.type == 'teams' && section.type !== 'media'" class="subsection-main-title">{{page.name}}</h1>
				</div>
			</div>
		</div>

		<div class="row page news-page" v-if="page && $route.params.subsectionSlug == 'dernieres-news'">
			<div class="col-lg-8 col-12">
				<div class="row">
					<div class="col-12">
						<div class="section__fullscreen-bg gsap-fade-up"
							v-if="page.fields && page.fields.image.value && page.fields.image.value.length"
							:style="{backgroundImage: 'url('+normal(page.fields.image.value[0])+')'}"></div>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="row background-white gsap-fade-up">
							<div class="col-12">
								<div class="component__page-description">
									<h6 class="subtitle">{{page.fields.news_date.value | dateFormat}}</h6>
									<h1 class="title">{{page.title}}</h1>	
									<div v-html="page.content"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-4">
				<div class="component__news-list">
					<ul>
						<li v-for="(article, index) in latestNews" :key="article.id" v-if="article.slug != $route.params.pageSlug && index < 4">
							<router-link :to="{name: 'page', params: {sectionSlug: 'news', subsectionSlug: 'dernieres-news', pageSlug: article.slug}}" href="">
								<div class="img" v-if="article.fields.image.value && article.fields.image.value.length" :style="{backgroundImage: 'url('+thumbnail(article.fields.image.value[0])+')'}"></div>
								<div class="content">
									<span>{{article.fields.news_date.value | dateFormat}}</span>
									<h6>{{article.title}}</h6>
								</div>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<!-- Media - Photos/videos -->
		<div v-if="subsection && subsection.type == 'photos_videos'" class="row photos-videos__page">
			<div class="col">
				<div class="photos-videos__page-block">
					<div class="header">
						<p class="date" v-if="page.fields.date">{{page.fields.date.value}}</p>
						<p class="title">{{page.title}}</p>
					</div>
					<swiper :options="sliderOptions" ref="mySwiper" class="gallery gsap-fade">
						<swiper-slide v-for="(media, index) in page.fields.gallery_images.value" :key="index">
							<img :src="normal(media)" alt="">
						</swiper-slide>
					</swiper>
					<div class="photos-videos__nav">
						<div class="img-block swiper-button-prev">
							<img class="prev" src="/images/arrow-left.svg" alt="">
						</div>
						<p class="swiper-pagination"  slot="pagination"></p>
						<div class="img-block swiper-button-next">
							<img class="next" src="/images/arrow-left.svg" alt="">
						</div>
					</div> 					
				</div>
			</div>
		</div>

		<!-- Teams pages -->
		<team-players-component v-else-if="section.type == 'teams'"></team-players-component>
	</div>

</template>

<script>

	import _find from 'lodash/find'
	import _orderBy from 'lodash/orderBy'
	import { mapState } from 'vuex'
	import teamPlayers from './teams/team-players-component.vue'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'

	export default {
		name: 'PageComponent',
		components: {
			'team-players-component': teamPlayers,
			swiper,
			swiperSlide,
		},
		data () {
			return {
				sliderOptions: {
					slidesPerView: 1,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction'
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}					
				},				
				params: {
					title: '',
					description: '',
					descriptionTwitter: '',
					titleTwitter: '',                
					descriptionFacebook: '',
					titleFacebook: '',
					image: '',
					imageTwitter: '',
					imageFacebook: '',
					linkCanonical: ''
				}
			}
		},
		head: {
			title: function () {
				return {
					inner: this.params.title,
					separator: ' '
				}
			},
			meta: function () {
				return [
					{ n: 'description', c: this.params.description},
					{ n: 'keywords', c: this.params.keywords},
					{ n: 'twitter:title', c: this.params.titleTwitter},
					{ n: 'twitter:description', c: this.params.descriptionTwitter},
					{ n: 'twitter:image', c: `${url}/uploads/${this.params.imageTwitter}`},
					{ p: 'og:title', c: this.params.titleFacebook },
					{ p: 'og:description', c: this.params.descriptionFacebook},
					{ p: 'og:image', c: `${url}/uploads/${this.params.imageFacebook}`},
					{ p: 'og:url', h: `${url}`}
				]
			},
			link: function() {
				return [
					{ r: 'canonical', h: this.params.linkCanonical}
				]
			}
		},
		watch: {
			'$route': function() {
				this.fetchData();
			}
		},
		mounted() {
			this.fetchData()
		},
		methods: {
			fetchData: function () {
				this.$nextTick( () => {
					if (this.section.type == 'teams') {
						this.params.title = this.page.name;
						this.params.titleTwitter = this.page.name;
						this.params.titleFacebook = this.page.name;
						this.params.image = this.page.image;
						this.params.imageTwitter = this.page.image;
						this.params.imageFacebook = this.page.image;
					} else {
						this.params = this.formatMeta(this.page)
					}

					this.$emit('updateHead')
					this.fade('.gsap-fade')
					this.fadeUp('.gsap-fade-up')
				})
			},
			// Animations
			fadeUp(el) {
				TweenMax.staggerFromTo(el, 0.7, {opacity: 0, y:30}, {opacity: 1, y:0}, 0.2)
			},
			fade(el) {
				TweenMax.staggerFromTo(el, 0.7, {opacity: 0}, {opacity: 1}, 0.2)
			}
		},
		computed: {
			...mapState({
				pages: 'pages',
				sections: 'allSections',
				teams: 'teams',
				teamsWithCategories: 'teamsWithCategories'
			}),
			page() {
				if (this.section.type == 'teams') {
					return _find(this.teams, {slug: this.$route.params.pageSlug})
				} else {
					return _find(this.pages, {slug: this.$route.params.pageSlug})
				}
			},
			section() {
				return _find(this.sections, {slug: this.$route.params.sectionSlug})
			},
			subsection() {
				return _find(this.sections, {slug: this.$route.params.subsectionSlug})
			},
			teamSection() {
				return _find(this.teamsWithCategories, {slug: this.$route.params.subsectionSlug})
			},
			news() {
				return _find(this.sections, {type: 'news'});
			},
			latestNews () {
				if (this.news) {
					return _orderBy(this.news.collections[0].pages, o => moment(o.fields.news_date.value, 'DD/MM/YYYY').format('YYYY.MM.DD'), ['desc']);
				}

				return [];
			}
		}
	}
</script>
